<template>
    <div
        class="task"
        :class="checked ? 'checked' : ''">
        <b-form-checkbox
            class="apprentice-checkbox custom-default-checkbox"
            v-model="checked"
            :value="1"
            :disabled="!!teacherAccess"
            :unchecked-value="0"
            @change="updateTaskCheckedState">
            <div class="task-header">
                <span>{{ taskIn.name }}</span>
                <span
                    class="date"
                    v-if="taskIn.personal_goal_task_deadline && taskIn.personal_goal_task_deadline.agenda_item"
                    >{{ taskIn.personal_goal_task_deadline.agenda_item.date | date_named_month }}</span
                >
            </div>
        </b-form-checkbox>
    </div>
</template>

<script>
export default {
    name: 'design-2021-personal-goal-widget-task-component',
    props: {
        taskIn: Object,
        teacherAccess: Number,
    },
    data() {
        return {
            checked: this.taskIn.checked,
        };
    },
    methods: {
        updateTaskCheckedState(checked) {
            if (this.teacherAccess) return;

            const data = {
                checked: checked,
            };

            this.axios.post(this.routes.personalGoalTaskStatusUpdate(this.taskIn.id), data).then(
                (response) => {
                    this.taskIn.update(response.data);
                },
                (error) => {
                    return this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.task.checked ::v-deep {
    label {
        font-weight: $font-weight-medium;
        color: $success;
        text-decoration: line-through;
        text-decoration-color: $success;
        text-decoration-thickness: 2px;
    }

    input[type='checkbox']:checked ~ .custom-control-label:before {
        color: $success;
    }

    .date {
        color: $success;
        font-weight: $font-weight-medium;
    }
}

.task ::v-deep {
    label {
        width: 100%;

        .task-header {
            flex: 1 0 100%;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            align-items: center;
        }

        .date {
            color: $text-muted-color;
        }
    }
}
</style>
